import React from 'react'
import Categories from '../../components/Categories/Categories'
import FeaturedProducts from '../../components/FeaturedProducts/FeaturedProducts'
import Slider from '../../components/Slider/Slider'
//import "./Home.scss"
const Home = () => {
  return (
    <div className='home'>
      <Slider/>
      <Categories/>
      <FeaturedProducts type="1"/>
      <FeaturedProducts type="2"/>
    </div>
  )
}

export default Home